// extracted by mini-css-extract-plugin
export default {"semester":"SemesterSection_semester__s3yGS","semesterHeader":"SemesterSection_semesterHeader__bHrJ4"};